function getSubSector(selectedSectors, catalogSubSectors) {
  var result = [];

  catalogSubSectors.forEach((elem) => {
    if (Object.hasOwn(elem, "filteredL1")) {
      if (selectedSectors.includes(elem.filteredL1[0].id)) {
        result.push({ key: elem.id, value: elem.name });
      }
    } else {
      result.push({ key: elem.id, value: elem.name });
    }
  });
  return result;
}

export default getSubSector;
